module.exports = __webpack_public_path__ + "img/search.ea12f6ac.svg";